import { Box, Button, styledComponent, Typography } from '@hermes/web-components'

export const ContainerForNoResults = styledComponent(Box)(() => ({
  display: 'flex',
  width: '100%',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '40px',
  height: '361px',
  flexDirection: 'column'
}))

export const MainText = styledComponent(Typography)(() => ({
  fontSize: '18px',
  fontWeight: 500,
  color: '#2C3341'
}))

export const SecondaryText = styledComponent(Typography)(() => ({
  fontSize: '14px',
  fontWeight: 400,
  paddingLeft: '40px',
  paddingRight: '40px',
  textAlign: 'center',
  color: '#2C3341'
}))

export const TextContainer = styledComponent(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  justifyContent: 'center',
  alignItems: 'center'
}))

export const NestedContainer = styledComponent(TextContainer)(() => ({
  gap: '24px'
}))

export const ClearButton = styledComponent(Button)(() => ({
  width: '147px',
  height: '40px',
  borderRadius: '24px',
  fontSize: '15px',
  fontWeight: 500,
  backgroundColor: 'transparent',
  color: '#051851',
  border: '1px solid #051851'
}))
